export enum EWithdrawStatus {
    IN_PROGRESS = 'InProgress',
    SUCCESS = 'Succeeded',
    ERROR = 'Error',
    // Card withdrawals only: admin approval queues the request for the automatic Unlimit payout.
    APPROVED = 'Approved',
    // The payout job claimed the request; the provider outcome moves it to Succeeded/Error.
    PROCESSING = 'Processing',
}
